export default "__VITE_ASSET__Dae2vHD0__"